/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FlushingPrinciple {
  Blank = 'Blank',
  Manual = 'Manual',
  Start = 'Start',
  Finish = 'Finish'
}
